import { useFeature } from 'src/core/common/hooks/useFeature';
import FEATURES from 'src/core/constants/features';
import { useIsCompanyOnSfsUk } from 'src/core/modules/company/hooks';

export const useShouldVerifyTransfersBeneficiaries = () => {
  const isSfsUk = useIsCompanyOnSfsUk();
  return useFeature(FEATURES.TMP_CONFIRMATION_OF_PAYEE) && isSfsUk;
};
